export const NumberInput = ({ placeHolder, value, onChanged, isInvalid = false, disabled = false }) => {
  const inputValue = !value && value !== 0 ? '' : value
  return <input
    placeholder={placeHolder}
    type="number" inputMode="numeric"
    className={`text-right input-form-text ${isInvalid ? ' border-red-500':''}`}
    onChange={onChanged}
    value={inputValue}
    disabled={disabled}
  />
}